import * as THREE from 'three'

export type CraterWorld='klavius'|'solara'
export const cityCraterDimensions=(cityRadius:number)=>({inner:cityRadius*1.32+4,width:cityRadius*.7,height:cityRadius*.22,outer:cityRadius*2.02+4})

// The flat floor contains the entire pressure dome; the terraced inner wall
// and ejecta apron begin outside it, leaving streets and properties clear.
export function createCityCraterGeometry(cityRadius:number,world:CraterWorld){
  const {inner,width,height}=cityCraterDimensions(cityRadius),segments=192,rings=32
  const positions:number[]=[],colors:number[]=[],uvs:number[]=[],indices:number[]=[]
  const floor=new THREE.Color(world==='solara'?'#a76b4b':'#747b84'),ridge=new THREE.Color(world==='solara'?'#d6a07a':'#b6bec5')
  const profile=[[0,0],[.14,.09],[.27,.32],[.35,.36],[.44,.72],[.53,1],[.62,.89],[.78,.4],[1,0]]
  for(let j=0;j<=rings;j++){
    const t=j/rings;let k=0;while(k<profile.length-2&&t>profile[k+1][0])k++
    const [a,ya]=profile[k],[b,yb]=profile[k+1],rise=ya+(yb-ya)*(t-a)/(b-a)
    for(let i=0;i<=segments;i++){
      const angle=i/segments*Math.PI*2
      const ripple=Math.sin(angle*5+.7)*.034+Math.sin(angle*11)*.017+Math.cos(angle*19+.4)*.009
      const radius=inner+width*t+width*ripple*Math.sin(t*Math.PI)
      const gullies=(Math.sin(angle*37+.7)*.035+Math.sin(angle*59)*.022)*Math.sin(t*Math.PI)
      const y=-.39+height*Math.max(0,rise*(1+Math.sin(angle*7)*.12+Math.cos(angle*13)*.06)+gullies)
      positions.push(Math.cos(angle)*radius,y,Math.sin(angle)*radius)
      const color=floor.clone().lerp(ridge,THREE.MathUtils.clamp(.16+rise*.58+Math.sin(angle*37+.7)*.1+Math.sin(t*52)*.04,0,1))
      colors.push(color.r,color.g,color.b);uvs.push(i/segments*18,t*5)
      if(i<segments&&j<rings){const n=j*(segments+1)+i;indices.push(n,n+1,n+segments+1,n+1,n+segments+2,n+segments+1)}
    }
  }
  const geometry=new THREE.BufferGeometry()
  geometry.setAttribute('position',new THREE.Float32BufferAttribute(positions,3));geometry.setAttribute('color',new THREE.Float32BufferAttribute(colors,3));geometry.setAttribute('uv',new THREE.Float32BufferAttribute(uvs,2))
  geometry.setIndex(indices);geometry.computeVertexNormals();geometry.computeBoundingBox();geometry.computeBoundingSphere()
  return geometry
}
